module.exports = __webpack_public_path__ + "static/media/C11.eb759cd6.png";